import SEOHead from '../components/common/SEOHead';
import TravelGallery from '../components/gallery/TravelGallery';

const GalleryPage = () => {
  return (
    <>
      <SEOHead
        title="Travel Gallery"
        description="Explore our stunning travel photography from around the world. Discover beautiful destinations through our lens."
        path="/gallery"
      />

      <div className="min-h-screen bg-gray-50">
        {/* Header Section */}
        <section className="bg-gray-50 py-8">
          <div className="container-max relative z-10 text-center">
            <div className="space-y-4">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-gray-900 leading-tight">
                <span className="block">Travel</span>
                <span className="block text-blue-600 animate-pulse">
                  Gallery
                </span>
              </h1>
              <p className="text-xl md:text-2xl leading-relaxed text-gray-700 max-w-4xl mx-auto font-light">
                Journey with us through breathtaking destinations captured in
                stunning detail. Every image tells a story of adventure, wonder,
                and the magic of exploration.
              </p>
              <div className="flex items-center justify-center space-x-8 pt-8">
                <div className="text-center">
                  <div className="text-4xl font-bold text-blue-600">23+</div>
                  <div className="text-sm font-medium text-gray-600">
                    Travel Photos
                  </div>
                </div>
                <div className="w-px h-12 bg-blue-300"></div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-blue-600">15+</div>
                  <div className="text-sm font-medium text-gray-600">
                    Countries
                  </div>
                </div>
                <div className="w-px h-12 bg-blue-300"></div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-blue-600">∞</div>
                  <div className="text-sm font-medium text-gray-600">
                    Memories
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Gallery Section */}
        <section className="section-padding-sm">
          <div className="container-max relative z-10">
            <TravelGallery showTitle={false} />
          </div>
        </section>
      </div>
    </>
  );
};

export default GalleryPage;
